import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/account/app/')({
  beforeLoad: () => {
    throw redirect({ to: '/administration/account/app/data-collection' });
  },
});
